(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zebDshVendor", [], factory);
	else if(typeof exports === 'object')
		exports["zebDshVendor"] = factory();
	else
		root["zebDshVendor"] = factory();
})(self, () => {
return 